<template>
  <context-menu v-if="!isPeriodReconciled && canEdit">
    <div class="d-flex flex-column">
      <e-btn size="M" variant="context" :disabled="isReconcileDisabled" @click="onReconcileClick"> 
        Сверить 
      </e-btn>
      <e-btn 
        size="M" 
        variant="context"
        @click="onMismatchClick"
      > 
        Есть расхождения
      </e-btn>
    </div>
  </context-menu>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import ContextMenu from '@/core/components/common/ContextMenu.vue';
import { EBtn } from '@/core/components/ui';
import { ContractReconciliationStates, OrderReconciliationStatus, useReconcileOrdersReconciliationMutation } from '@/graphql/generated';

const props = defineProps<{
  item: {
    commonInfo: {
      orderId: number;
      orderReconciliationStatus: OrderReconciliationStatus;
    };
  };
  periodStatus?: ContractReconciliationStates;
  canEdit?: boolean;
}>();

const emit = defineEmits<{
  (event: 'reconciled'): void;
  (event: 'mismatchClick'): void;
}>();

const isPeriodReconciled = computed(
  () => props.periodStatus === ContractReconciliationStates.Reconciled
);

const isReconcileDisabled = computed(() => {
  const status = props.item.commonInfo.orderReconciliationStatus;
  return status === OrderReconciliationStatus.Reconciled 
    || status === OrderReconciliationStatus.ReconciledByAlean;
});

const onReconcileClick = async () => {
  if (isReconcileDisabled.value) return;

  const { request } = useReconcileOrdersReconciliationMutation({
    input: { orderIds: [props.item.commonInfo.orderId] },
  });

  await request();
  emit('reconciled');
};

const onMismatchClick = () => {
  emit('mismatchClick');
};
</script>

<style scoped lang="scss"></style>
